<script setup lang="ts">
import { useSlots, watchEffect } from "vue";

const slots = useSlots();

watchEffect(() => {
  const children = slots.default?.() ?? [];
  if (children.length === 0) {
    throw new Error(
      "SummaryCardGroup requires at least one SummaryCard child component."
    );
  }
});
</script>

<template>
  <div class="summary-card-group">
    <slot />
  </div>
</template>
